import { Tooltip, Typography } from "@mui/material";
import { truncate } from "lodash";

export function FileBlock({ name }: { name: string }) {
  return (
    <Tooltip title={name}>
      <Typography noWrap variant="body2">
        {truncate(name, { length: 30 })}
      </Typography>
    </Tooltip>
  );
}
